import { Calendar, Loader2 } from 'lucide-react';

interface DateRangePickerProps {
  selectedDays: number;
  onSelectDays: (days: number) => void;
  isLoading?: boolean;
}

const DATE_OPTIONS = [
  { value: 0, label: 'All Time' },
  { value: 30, label: '30 days' },
  { value: 60, label: '60 days' },
  { value: 90, label: '90 days' },
];

export const DateRangePicker = ({
  selectedDays,
  onSelectDays,
  isLoading = false,
}: DateRangePickerProps) => {
  return (
    <div className="flex items-center justify-end space-x-2">
      <Calendar className="h-5 w-5 text-gray-500" />
      <span className="text-sm font-medium text-gray-700">Date Range:</span>
      <select
        value={selectedDays}
        onChange={e => onSelectDays(Number(e.target.value))}
        disabled={isLoading}
        className={`px-3 py-1.5 text-sm font-medium rounded-md border border-gray-300 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
          isLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
        }`}>
        {DATE_OPTIONS.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {isLoading && <Loader2 className="h-4 w-4 animate-spin text-blue-600" />}
    </div>
  );
};
